






































import { Component, Prop, Vue } from 'vue-property-decorator';
const { VUE_APP_FCAPI: FCAPI } = process.env;
import { AxiosResponse } from 'axios';
const uuidv4 = require('uuid/v4');
const API = {
  tester: `${FCAPI}/shang/weixin/open/tester`, // 体验者
};
const default_number = 15;

@Component
export default class Release extends Vue {
  isLoading: boolean = false;
  tagList: any = [];
  isShowModel: boolean = false;
  wechat: any = '';
  number: any = default_number;

  async query() {
    this.isLoading = true;
    const res: AxiosResponse = await this.$axios.get(API.tester);
    const remote = res.data;
    if (remote.status !== 200) {
      console.debug(remote.message);
      this.isLoading = false;
      return;
    }
    this.tagList = remote.data;
    this.number = default_number - this.tagList.length;
    this.isLoading = false;
  }

  async addTester() {
    if (!this.wechat) {
      this.$message.error('请输入微信号');
      return;
    }

    const res: AxiosResponse = await this.$axios.post(API.tester, {
      wechat_id: this.wechat,
    });

    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      this.isShowModel = false;
      return;
    }
    this.$message.success('添加成功');
    this.wechat = '';
    await this.query();
  }

  async removeTester(wechat_id: any) {
    const res: AxiosResponse = await this.$axios.delete(
      `${API.tester}/${wechat_id}`
    );

    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      return;
    }
    this.$message.success('删除成功');
    await this.query();
  }

  async created() {
    await this.query();
  }
}
